import { render, staticRenderFns } from "./Rejected.vue?vue&type=template&id=49c99090&scoped=true"
import script from "./Rejected.vue?vue&type=script&lang=js"
export * from "./Rejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c99090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c99090')) {
      api.createRecord('49c99090', component.options)
    } else {
      api.reload('49c99090', component.options)
    }
    module.hot.accept("./Rejected.vue?vue&type=template&id=49c99090&scoped=true", function () {
      api.rerender('49c99090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Rejected.vue"
export default component.exports